<template>
  <article :id="$vnode.key">
    <custom-callout
      ref="callout"
      :has-toggle="true"
      :controlled="true"
      :opened="isOpen"
      class="mt-2 mb-3"
      @click:open="toggleCallout()"
    >
      <div class="container-fluid">
        <div class="row">
          <div class="col-6 col-md">
            <div class="info-text-title">Región:</div>
            <p class="info-text">
              {{ value.region.name }}
            </p>
          </div>
          <div class="col-6 col-md">
            <div class="info-text-title">Municipio:</div>
            <p class="info-text">
              {{ value.municipality.name }}
            </p>
          </div>
          <div class="col-6 col-md-2">
            <div class="info-text-title">Escuela:</div>
            <p class="info-text">
              {{ value.school.name }}
            </p>
          </div>
          <div class="col-6 col-md-2">
            <div class="info-text-title">Cantidad de Alternativas:</div>
            <p class="info-text">
              {{ value.numberOfAlternatives }}
            </p>
          </div>
          <div class="col-6 col-md-2">
            <div class="info-text-title">Resumen Cantidad de Estudiantes:</div>
            <p class="info-text">
              {{ value.studentsTotalResume }}
            </p>
          </div>
          <div class="col-6 col-md-2">
            <div class="info-text-title">
              Cantidad de Estudiantes en Certificación de Child Count
            </div>
            <p class="info-text">
              {{ value.childCount }}
            </p>
          </div>
          <div
            class="col-12 col-md-2 px-0 mt-2 mt-md-0 d-md-flex justify-content-center"
          >
            <div class="align-self-center">
              <ActionButton
                text="Ver Alternativas"
                variant="outline-success"
                :responsive="true"
                i="fas fa-search"
                @click="toggleCallout"
              />
            </div>
          </div>
        </div>
      </div>
      <template #edition>
        <div class="additional-container">
          <div class="p2 mt-1">
            <div class="bg-gray p-2">
              <div class="bg-white p-3 rounded pl-c-xl">
                <span class="mt-1">
                  <i class="fa fa-info-circle mr-2 color-primary-2" />
                  <span class="title color-gray-7 font-weight-bold">
                    Alternativa(s) de Ubicación
                  </span>
                </span>
                <div v-for="item in collections.searchResult">
                  <custom-callout
                    :key="item.id"
                    :has-toggle="false"
                    class="mt-3"
                  >
                    <div class="row pt-2">
                      <div class="col-6 col-md-3">
                        <div class="info-text-title">
                          Categoría de la Alternativa:
                        </div>
                        <p class="info-text">
                          {{ item.id }} - {{ item.category.name }}
                        </p>
                      </div>
                      <div class="col-6 col-md-3">
                        <div class="info-text-title">
                          Nombre de la Alternativa:
                        </div>
                        <p class="info-text">
                          {{ item.alternative.name }}
                        </p>
                      </div>
                      <div class="col-6 col-md-2">
                        <div class="info-text-title">Nombre del Maestro:</div>
                        <p class="info-text">
                          {{ (item.teacher && item.teacher.name) || '-' }}
                        </p>
                      </div>
                      <div class="col-6 col-md-2">
                        <div class="info-text-title">Grado(s):</div>
                        <p class="info-text">
                          <span
                            class="d-flex"
                            v-text="
                              item.grades.map((x) => x.name).join(', ') || '-'
                            "
                          />
                        </p>
                      </div>
                      <div
                        class="col-12 col-md-2 d-md-flex justify-content-center"
                      >
                        <div class="align-self-center">
                          <ActionButton
                            text="Entrar"
                            variant="outline-success"
                            :responsive="true"
                            i="fas fa-file-import"
                            @click="goManagement(item.id)"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="row pt-2">
                      <div class="col col-md-3">
                        <div class="info-text-title">Total de Estudiantes:</div>
                        <p class="info-text">
                          {{ item.numberOfStudents }}
                        </p>
                      </div>
                      <div class="col col-md-3">
                        <div class="info-text-title">
                          Especialidad de Salón:
                        </div>
                        <p class="info-text">
                          {{ item?.salonSpeciality?.name | empty }}
                        </p>
                      </div>
                      <div class="col col-md-2">
                        <div class="info-text-title">Cupo:</div>
                        <p class="info-text">
                          {{ item?.studentCapacity | empty }}
                        </p>
                      </div>
                      <div class="col col-md-2">
                        <div class="info-text-title">Conteo Asistente:</div>
                        <p class="info-text">
                          {{ formatAssistantCount(item.numberOfAssistants) }}
                        </p>
                      </div>
                    </div>
                  </custom-callout>
                  <div
                    v-if="item.updatedQuota"
                    class="rb-alert rounded-bottom pr-2 px-md-3 d-flex align-items-center alert-pending"
                  >
                    <i class="fas fa-bell-exclamation font-24 mx-3 ml-lg-2"></i>

                    <p class="font-weight-normal my-auto font-14">
                      El cupo de estudiantes ha sido modificado debido a la
                      siguiente razón [{{ item.updatedQuotaReason }}]
                    </p>
                  </div>
                </div>

                <CustomResultNotFound
                  v-if="showNotResults"
                  class="mt-4 row pt-3"
                  text="No cuenta información disponible."
                />
                <div class="row pt-2">
                  <div class="col-12 pt-0">
                    <Pagination
                      v-if="pagination.totalItemCount > pagination.perPage"
                      :data="pagination"
                      :page-size="pagination.perPage"
                      :parent-id="$vnode.key"
                      @pagination-go-page="requestAdditionalInfo"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </custom-callout>
  </article>
</template>

<script>
import CustomCallout from 'custom-callout';
import ActionButton from 'ActionButton';
import Pagination from 'pagination';
import CustomResultNotFound from 'custom-result-not-found';
import { getSchoolAlternativeLocations } from '@/modules/alternative-location-management/api';
export default {
  name: 'SearchResultRowSimple',
  components: {
    CustomCallout,
    ActionButton,
    Pagination,
    CustomResultNotFound,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isOpen: false,
      loaded: false,
      collections: {
        searchResult: [],
      },
      pagination: {
        perPage: 5,
        currentPage: 1,
        totalItemCount: 0,
        pageCount: 0,
        count: 0,
      },
    };
  },
  computed: {
    showNotResults() {
      return this.collections.searchResult.length == 0 && this.loaded;
    },
  },
  methods: {
    async toggleCallout() {
      this.isOpen = !this.isOpen;
      if (!this.isOpen || this.loaded) return;
      await this.requestAdditionalInfo();
      this.loaded = this.isOpen;
    },
    async requestAdditionalInfo(page = 1) {
      this.pagination.currentPage = page;
      const mappedFilter = {
        academicYearId: this.value.academicYear?.id,
        schoolId: this.value.school?.id,
        pageIndex: page,
        pageSize: this.pagination.perPage,
      };

      await getSchoolAlternativeLocations(mappedFilter).then((res) => {
        this.collections.searchResult = res.data.data;
        this.pagination = {
          ...this.pagination,
          totalItemCount: res.data.totalItemCount,
          pageCount: res.data.pageCount,
          currentPage: res.data.currentPage,
          count: res.data.count,
        };
      });
    },
    goManagement(id) {
      this.$router.push(`/humanres/locationalternativemanagement/${id}`);
    },
    formatAssistantCount(count) {
      return (count || 0).toString().padStart(2, '0');
    },
  },
};
</script>

<style lang="scss" scoped>
@use "sass:map";
@import '@/assets/scss/variables/_colors.scss';

.info-text-title {
  color: map.get($colors, 'gray-6');
  font-size: 1rem;
  font-weight: normal;
}

.info-text {
  color: map.get($colors, 'black');
  font-weight: normal;
  font-size: 1rem;
  size: 1rem;
}
.rb-alert {
  top: 97%;
  left: 0;
  width: 100%;
  padding: 10px 0;
}
.alert-pending {
  background-color: #fff5e8;

  & p,
  i {
    color: #af6708;
  }
}
</style>
